import { useState } from 'react'

const useInputError = onError => {
  const [errorMessage, setErrorMessage] = useState(null)
  const handleError = e => {
    if (e.target.validity.valid) {
      setErrorMessage(null)
    } else {
      setErrorMessage(onError(e))
    }
  }
  return {
    errorMessage,
    handleError,
    setErrorMessage,
  }
}

export default useInputError
